export const categoryDetails = [
    {
        default: require('@/assets/精致眼眉/柔光幻彩单色眼影/tu-1_02.jpg'),
        active: require('@/assets/精致眼眉/柔光幻彩单色眼影/tu_02.jpg'),
        describe: require('@/assets/精致眼眉/柔光幻彩单色眼影/tu-1_06.jpg'),
        describe1: '柔光幻彩单色眼影',
        describe2: '各种颜色 玩转眼妆'
    },
    {
        default: require('@/assets/精致眼眉/二十色「油画盘」/tu-1_03.jpg'),
        active: require('@/assets/精致眼眉/二十色「油画盘」/tu_03.jpg'),
        describe: require('@/assets/精致眼眉/二十色「油画盘」/tu-1_07.jpg'),
        describe1: '二十色「油画盘」',
        describe2: '一盘领略梦幻眼妆'
    },
    {
        default: require('@/assets/精致眼眉/二十色「加州盘」/tu-1_04.jpg'),
        active: require('@/assets/精致眼眉/二十色「加州盘」/tu_04.jpg'),
        describe: require('@/assets/精致眼眉/二十色「加州盘」/tu-2_08.jpg'),
        describe1: '二十色「日落盘」',
        describe2: '质感配色 描绘双眸神采'
    },
    {
        default: require('@/assets/精致眼眉/七色盘/tu-1_05.jpg'),
        active: require('@/assets/精致眼眉/七色盘/tu_05.jpg'),
        describe: require('@/assets/精致眼眉/七色盘/tu-1_09.jpg'),
        describe1: '七色玩趣组合盘',
        describe2: '—盘搞定全脸妆容'
    },
    {
        default: require('@/assets/精致眼眉/钻石眼泪液体眼影/tu-1_10.jpg'),
        active: require('@/assets/精致眼眉/钻石眼泪液体眼影/tu_10.jpg'),
        describe: require('@/assets/精致眼眉/钻石眼泪液体眼影/tu-1_14.jpg'),
        describe1: '钻石眼泪液体眼影',
        describe2: '梦幻光耀 点亮眼妆'
    },
    {
        default: require('@/assets/精致眼眉/云柔朵朵四色眼影/tu-1_11.jpg'),
        active: require('@/assets/精致眼眉/云柔朵朵四色眼影/tu_11.jpg'),
        describe: require('@/assets/精致眼眉/云柔朵朵四色眼影/tu_15.jpg'),
        describe1: '云柔朵朵四色眼影',
        describe2: '新手四色 清透闪耀'
    },
    {
        default: require('@/assets/精致眼眉/极细眼线笔「小花笔」/tu-1_12.jpg'),
        active: require('@/assets/精致眼眉/极细眼线笔「小花笔」/tu_12.jpg'),
        describe: require('@/assets/精致眼眉/极细眼线笔「小花笔」/tu-2_16.jpg'),
        describe1: '极细眼线笔「小花笔」',
        describe2: '勾勒你的专属眼色'
    },
    {
        default: require('@/assets/精致眼眉/丝柔防水眼线胶笔/tu-1_13.jpg'),
        active: require('@/assets/精致眼眉/丝柔防水眼线胶笔/tu-2_13.jpg'),
        describe: require('@/assets/精致眼眉/丝柔防水眼线胶笔/tu-1_17.jpg'),
        describe1: '丝柔防水眼线胶笔',
        describe2: '流畅勾画 点亮双眸'
    },
    {
        default: require('@/assets/精致眼眉/「极光」眼线液笔/tu-1_18.jpg'),
        active: require('@/assets/精致眼眉/「极光」眼线液笔/tu_18.jpg'),
        describe: require('@/assets/精致眼眉/「极光」眼线液笔/tu-2_22.jpg'),
        describe1: '「极光」眼线液笔',
        describe2: '一笔出色精彩不停'
    },
    {
        default: require('@/assets/精致眼眉/定型纤长睫毛打底膏/tu-2_19.jpg'),
        active: require('@/assets/精致眼眉/定型纤长睫毛打底膏/tu_19.jpg'),
        describe: require('@/assets/精致眼眉/柔光幻彩单色眼影/tu-1_06.jpg'),
        describe1: '定型纤长睫毛打底膏',
        describe2: '持妆定型纤长加倍'
    },
    {
        default: require('@/assets/精致眼眉/「小花棒」纤长睫毛膏/tu-1_20.jpg'),
        active: require('@/assets/精致眼眉/「小花棒」纤长睫毛膏/tu_20.jpg'),
        describe: require('@/assets/精致眼眉/「小花棒」纤长睫毛膏/tu-2_24.jpg'),
        describe1: '「小花棒」纤长睫毛膏',
        describe2: '小巧刷头温水可卸'
    },
    {
        default: require('@/assets/精致眼眉/纤长炫翘双头睫毛膏/tu-1_21.jpg'),
        active: require('@/assets/精致眼眉/纤长炫翘双头睫毛膏/tu_21.jpg'),
        describe: require('@/assets/精致眼眉/纤长炫翘双头睫毛膏/tu-1_25.jpg'),
        describe1: '纤长炫翘双头睫毛膏',
        describe2: '天生纤长卷翘分明'
    },
    {
        default: require('@/assets/精致眼眉/纤细「小三角」眉笔/tu-2_26.jpg'),
        active: require('@/assets/精致眼眉/纤细「小三角」眉笔/tu_26.jpg'),
        describe: require('@/assets/精致眼眉/纤细「小三角」眉笔/tu-2_30.jpg'),
        describe1: '纤细「小三角」眉笔',
        describe2: '轻松勾勒好眉形'
    },
    {
        default: require('@/assets/精致眼眉/柔焦雾感塑形眉笔/tu-2_27.jpg'),
        active: require('@/assets/精致眼眉/柔焦雾感塑形眉笔/tu_27.jpg'),
        describe: require('@/assets/精致眼眉/柔焦雾感塑形眉笔/tu-2_31.jpg'),
        describe1: '柔焦雾感塑形眉笔',
        describe2: '顺滑持久 自然塑形'
    },
    {
        default: require('@/assets/精致眼眉/防水塑形眉膏/tu-2_28.jpg'),
        active: require('@/assets/精致眼眉/防水塑形眉膏/tu_28.jpg'),
        describe: require('@/assets/精致眼眉/防水塑形眉膏/tu-1_32.jpg'),
        describe1: '防水塑形眉膏',
        describe2: '「无眉」星人救星'
    },
]